import Vue from 'vue'
import App from './App.vue'
import router from './router' //引入 vue-router
import store from './store' //引入 vuex

import '@/custom/plugins/el_custom' //自定义
import '@/custom/styles/responsive.scss'

//  第三方包
import 'element-ui/lib/theme-chalk/index.css' //element-ui样式
import ElementUI from 'element-ui'
Vue.use(ElementUI)
import 'animate.css'

Vue.config.productionTip = false

//Vue 提供了一个全局的错误处理器，可以捕获来自 'Vue 组件'的错误。可以在主 JavaScript 文件(如 main.js)中设置这个处理器：
Vue.config.errorHandler = function (err, vmVue, info) {
  // 捕获的错误信息
  // console.error('[Error]:', err);
  // console.error('[Info]:', info);
  Vue.prototype.$elNotify('Vue捕获错误信息', 'error:' + err, 'error')
  // 在这里可以进行错误上报或其他操作
};

//window.onerror来捕获全局的 JavaScript 错误。当一个Promise被reject且没有被catch捕获时，这个错误会冒泡到全局错误处理函数。
//不过需要注意的是，window.onerror虽然可以捕获未捕获的Promise.reject，但它也会捕获其他类型的全局 JavaScript 错误，如语法错误、运行时错误等。
window.onerror = function (msg, url, lineNo, columnNo, error) {
  //console.log('捕获到全局错误:', msg);
  Vue.prototype.$elNotify('捕获到全局错误信息', 'error:' + msg, 'error', 3000)
  // 可以在这里添加更复杂的错误处理逻辑，比如上报错误到服务器
  return false; // 阻止浏览器默认的错误处理行为
};

//使用window.addEventListener('unhandledrejection', callback)专门捕获未处理的Promise拒绝reject;
// 这是一种更精准地捕获未处理Promise.reject的方式。当一个Promise被reject且没有catch块来处理时，就会触发unhandledrejection事件。
// event.reason包含了Promise被拒绝的原因。通过event.preventDefault()可以阻止事件的默认行为，避免在控制台输出未处理Promise拒绝的默认消息。
window.addEventListener('unhandledrejection', function (event) {
  //console.log('捕获到未处理的Promise拒绝:', event.reason);
  Vue.prototype.$elNotify('捕获到未处理的Promise错误', 'error:' + event.reason, 'error')
  // 可以在这里对未处理的Promise拒绝进行处理，比如显示一个友好的错误提示给用户
  // 防止事件继续冒泡
  event.preventDefault();
});

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
